export default "__VITE_ASSET__CFchCvCL__"